export default "__VITE_ASSET__e5f413e0__"